import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// const root = document.getElementById('react-root');
const wrappers = document.querySelectorAll('.react-form-wrapper');

wrappers.forEach((container) => {
  // console.log("mounting react on:", container.id);
  // props coming from the dynamically enqueued react divs
  const containerId = container.id;
  const formType = container.getAttribute('data-form-type');
  const portalId = container.getAttribute('data-portal');

  const root = ReactDOM.createRoot(container);
  if (root) {
    root.render(<App id={containerId} type={formType} portal={portalId}/>);
  }
});

